import { differenceInDays, parseISO } from 'date-fns';

type isApprovalValidGRProps = {
  hasSomeApproval: boolean;
  lastApprovedDate: string;
};

export const isApprovalValidGR = ({ hasSomeApproval, lastApprovedDate }: isApprovalValidGRProps) =>
  hasSomeApproval && differenceInDays(new Date(), parseISO(lastApprovedDate)) <= 180;
